<script setup lang="ts">
import type {
  NovaBoxDaoNoticeListItemProps,
  ShowDaoNoticeModalParams,
} from './NovaBoxDaoNoticeListItem.types'

const props = defineProps<NovaBoxDaoNoticeListItemProps>()

const { gtEvent } = useGoogleTag()
const creatorStore = useCreatorStore()
const userStore = useUserStore()
const { show: modalShow } = useModal()

// Dao 공지사항 상세 모달 열기
const handleOnOpenNoticeDetail = async () => {
  if (props.viewType === 'list') {
    gtEvent('clickEvent', {
      eventCategory: '클릭',
      eventAction: 'Dao 공지사항 상세보기',
      eventLabel: '',
      eventSlot: '',
      eventI18nAddr: '',
      eventComponent: 'Modal',
      daoNttSn: props.source.daoNttSn,
      nttSj: props.source.nttSj,
    })
    await modalShow(modalsName.MODAL_DAO_NOTICE_DETAIL, {
      source: props.source,
    } as ShowDaoNoticeModalParams)
  }
}
</script>

<template>
  <article
    :class="['post', `view-type-${viewType}`]"
    @click="handleOnOpenNoticeDetail"
  >
    <div class="header">
      <div class="info-bar">
        <div class="left-wrap creator-wrap">
          <NovaCreatorCell
            :user-name="creatorStore.profile?.userNcnm"
            :portrait="creatorStore.profile?.userProflUrl"
            :post-create-at="source?.nttRegistDt"
            :post-view-count="source?.rdCount"
          />
        </div>
        <NovaBoxDaoNoticeAction
          v-if="
            viewType !== 'detail' &&
            userStore.user?.userSn === creatorStore.profile?.userSn
          "
          :popover-append-target="null"
          :dao-ntt-sn="source?.daoNttSn"
        />
      </div>
    </div>

    <div class="contents">
      <h4 v-dompurify-html="source.nttSj" class="post-title" />

      <NovaBoxPostContentsSnapshotContents
        :contents="source?.nttCn"
        :view-type="viewType"
        class="post-contents"
      />
    </div>
  </article>
</template>

<style lang="scss" scoped>
.post {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  //max-height: 634px;
  padding: 20px;
  border-radius: 20px;
  background-color: $color-bg-3;
  box-shadow: 5px 5px 10px 0 hex-to-rgba($color-bg-custom-4, 0.05);
  @include transition(box-shadow 0.2s);

  &.view-type {
    &-list {
      cursor: pointer;

      @media (hover: hover) {
        &:hover {
          box-shadow: 0 5px 10px 10px hex-to-rgba($color-bg-custom-4, 0.05);
        }
      }
    }

    &-detail {
      //max-height: 100%;
      //.contents .post-contents { height: auto; }
    }
  }

  .header {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .info-bar {
      display: flex;
      align-items: center;
      gap: 20px;
      justify-content: space-between;

      .left-wrap {
        display: flex;
        align-items: center;

        .creator-badge {
          margin-left: 2px;
        }

        .create-at {
          margin-left: 20px;
          @include text-style($text-body-11-medium);
          color: $color-text-3;
        }

        > .follow {
          flex-shrink: 0;
          padding: 0;
          margin-left: 20px;
          @include text-style($text-body-11-medium);

          &.status {
            &-required-signin {
              color: $color-black;
            }

            &-follow {
              color: $color-sky-blue;
            }

            &-following {
              color: $color-text-3;
            }
          }
        }
      }

      .meta-info {
        display: flex;
        gap: 20px;

        .meta {
          @include text-style($text-body-14-regular);
          color: $color-text-3;
        }
      }
    }
  }

  .contents {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    gap: 20px;
    overflow: hidden;

    .post-title {
      flex-shrink: 0;
      @include text-style($text-heading2-bold);
      color: $color-text-2;
      @include ellipsis(2);
    }

    .post-contents {
      flex-grow: 1;
    }

    > .extras {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }
  }
}
</style>
